"use client";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { EmptyTable } from "components/Datatable/components/EmptyTable";
import { useMemo } from "react";
import { formatDateKeyForDisplay } from "@/utils/date";

export function GroupedTable({ data, columns }: any) {
  const groupedData = useMemo(() => {
    const groups: { [key: string]: any[] } = {};
    data?.forEach((item: any) => {
      const rawDate = item.conciliation_date;
      let dateKey = '';
      if (!rawDate || isNaN(new Date(rawDate).getTime())) {
        dateKey = 'invalid';
      } else {
        const d = new Date(rawDate);
        const year = d.getUTCFullYear();
        const month = String(d.getUTCMonth() + 1).padStart(2, '0');
        const day = String(d.getUTCDate()).padStart(2, '0');
        dateKey = `${year}-${month}-${day}`;
      }
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(item);
    });
    Object.entries(groups).forEach(([key, items]) => {
      console.log(`[GroupedTable] Grupo:`, key, 'Qtd:', items.length, 'Itens:', items);
    });
    return groups;
  }, [data]);


  return (
    <Table className="overflow-x-auto">
      <TableHeader className="sticky top-0 bg-[#F9FBFC] z-10 shadow-sm">
        <TableRow>
          {columns.map((column: any, i: number) => (
            <TableHead
              key={column.id || i}
              className={column.sticky ? `sticky  ${column.sticky} border-r z-20` : ""}
            >
              {typeof column.header === 'function' ? column.header() : column.header}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody className="relative overflow-x-auto">
        {data?.length > 0 ? (
          Object.entries(groupedData)
            .sort(([a], [b]) => {
              if (a === 'invalid') return 1;
              if (b === 'invalid') return -1;
              return new Date(b).getTime() - new Date(a).getTime();
            })
            .map(([dateKey, items]) => (
              <>
                <TableRow key={`group-${dateKey}`} className="bg-gray-50/50">
                  <TableCell colSpan={columns.length} className="py-2 sticky left-0 z-10">
                    <div className="font-medium flex items-center gap-2">
                      <span className="text-gray-500">📅</span>
                      {formatDateKeyForDisplay(dateKey) ?? <span className="text-red-500">Data inválida</span>}
                    </div>
                  </TableCell>
                </TableRow>
                {items.map((item, index) => (
                  <TableRow
                    key={`${dateKey}-${index}`}
                    data-conciliation-id={item.conciliatedDivergence?.id || ''}
                    className="transition-all duration-300"
                  >
                    {columns.map((column: any, colIndex: number) => (
                      <TableCell
                        key={`${dateKey}-${index}-${colIndex}`}
                        className={`${column.className ?? ""} ${column.sticky ? `sticky ${column.sticky} bg-white z-10 ${column.sticky === 'right-0' ? 'border-l' : 'border-r'}` : ""}`}
                        data-conciliation-id={item.conciliatedDivergence?.id || ''}
                      >
                        {column.cell ? column.cell({ row: { original: item } }) : item[column.accessorKey]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </>
            ))
        ) : (
          <TableRow>
            <TableCell colSpan={columns.length}>
              <EmptyTable />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
